/* eslint-disable */
export default {
  dialer: 'Kiestoetsen',
  allCalls: 'Alle oproepen',
} as const;

// @key: @#@"dialer"@#@ @source: @#@"Dial Pad"@#@
// @key: @#@"allCalls"@#@ @source: @#@"All Calls"@#@
